<template>
    <div class="py-4">
        <h3 class="pb-8 text-2xl">
            <span class="font-bold">Find tyres</span>
            for {{ manufacturer.name }} models
        </h3>

        <div v-if="models.length > 0" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <ModelBasicCard v-for="model of models" :model="model" :manufacturer="manufacturer"></ModelBasicCard>
        </div>
    </div>
</template>

<script>
import ModelBasicCard from "@/Components/Models/ModelBasicCard";

export default {
    components: {ModelBasicCard},
    props: {
        manufacturer: Object,
        models: Array
    }
};
</script>

<style scoped>

</style>
